import React, { useEffect, useState } from "react";
import { Card, Col, Form, ListGroup, Row } from "react-bootstrap";
import ZipsListItem from "./ZipsListItem";
import RangeSlider from 'react-range-slider-input';
import "react-range-slider-input/dist/style.css";
import { AiOutlineCheck } from "react-icons/ai";
import InvoiceClassCard from "../download/InvoiceClassCard";
import EnergoPagination from "../shared/EnergoPagination";

/**
 * used in ZipList - ArtchivePage
 * 
 * @param {zips} props array of zip objects
 */
const ZipsList = ({zips}) => {

    // pagination
    const [maxItemsInPagination, setMaxItemsInPagination] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentView, setCurrentView] = useState([]);

    const [monthRange, setMonthRange] = useState([1, 12]);
    const [years, setYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState(0);
    const [initialZips, setInitialZips] = useState(zips);
    const [filteredZips, setFilteredZips] = useState([]);

    const [selectedType, setSelectedType] = useState([]);
    const [types, setTypes] = useState([ // object state for types of invoices
        { id: 1, name: "Poolrechnungen", count: 0, last: "" },
        { id: 2, name: "Energielieferant", count: 0, last: "" },
        { id: 3, name: "Vorschreibungen", count: 0, last: "" },

    ]);


    useEffect(() => {
        if (zips !== undefined) {
            var current_year = Number(new Date().getFullYear());
            var year_list = [current_year];
            setInitialZips(zips);
            setFilteredZips(zips);

            if (zips.length > 0) {
                setCurrentView(zips.slice(0, maxItemsInPagination));
            } else {
                setCurrentView(zips);
            }

            for (var i = 0; i < zips.length; i++) {
                var y = Number(new Date(zips[i].downloaded * 1000).toLocaleDateString('DE-de').split('.')[2]);
                var index = year_list.findIndex(x => x === y);
                if (index === -1) year_list.push(y);
            }
            setYears(year_list);
            setSelectedYear(current_year)
        }
    }, [zips])

    useEffect(() => {
        if (zips.length > 0) {
            var start = (currentPage -1) * maxItemsInPagination;
            var end = currentPage * maxItemsInPagination;
            setCurrentView(filteredZips.slice(start, end));
        } else {
            setCurrentView(filteredZips);
        }
    }, [maxItemsInPagination, currentPage, filteredZips])


    useEffect(() => {
        checkActiveFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [monthRange])

    useEffect(() => {
        checkActiveFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedYear])


    useEffect(() => {
        checkActiveFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedType])


    const countInvoiceTypes = (fromArr) => {
        types[0].count = fromArr.filter(z =>
            z.name.toLowerCase().includes('poolrechnungen') ||
            (
                z.name.slice(0, 3) !== "JAR" &&
                z.name.slice(0, 3) !== "END" &&
                z.name.slice(0, 2) !== "MO" &&
                z.name.slice(0, 2) !== "VS" && 
                !z.name.includes("abrechnungen") && 
                !z.name.includes("vorschreibungen")
            )
        ).length;
        types[1].count = fromArr.filter(z => 
            z.name.toLowerCase().includes('abrechnungen') || 
            z.name.slice(0, 3) === "JAR" ||    
            z.name.slice(0, 3) === "END" ||
            z.name.slice(0, 2) === "MO"
        ).length;
        types[2].count = fromArr.filter(z => 
            z.name.toLowerCase().includes('vorschreibungen') ||
            z.name.slice(0, 2) === 'VS'
        ).length;
    }


    const checkActiveFilters = () => {
        var filtered = initialZips;
        var count = 0;
        if (monthRange[0] !== 1 || monthRange[1] !== 12) {
            filtered = filtered.filter(z => Number(new Date(z.downloaded * 1000).toLocaleDateString('DE-de').split('.')[1]) >= monthRange[0] && Number(new Date(z.downloaded * 1000).toLocaleDateString('DE-de').split('.')[1]) <= monthRange[1]);
            count++;
        }

        if (selectedYear !== 0) {
            filtered = filtered.filter(z => Number(new Date(z.downloaded * 1000).toLocaleDateString('DE-de').split('.')[2]) === selectedYear);
            count++;
        }

        if (selectedType.length > 0) {
            var filtered1 = [];
            var filtered2 = [];
            var filtered3 = [];
            for (var i=0; i < selectedType.length; i++) {
                if (selectedType[i] === 1) {
                    filtered1 = filtered.filter(z => 
                        z.name.toLowerCase().includes('poolrechnungen') ||
                        (
                            z.name.slice(0, 3) !== "JAR" &&
                            z.name.slice(0, 3) !== "END" &&
                            z.name.slice(0, 2) !== "MO" &&
                            z.name.slice(0, 3) !== "VOR" && 
                            z.name.slice(0, 2) !== 'VS' &&
                            !z.name.includes("abrechnungen") && 
                            !z.name.includes("vorschreibungen")
                        )
                    );
                }
                if (selectedType[i] === 2) {
                    filtered2 = filtered.filter(z => 
                        z.name.toLowerCase().includes('abrechnungen') || 
                        z.name.slice(0, 3) === "JAR" ||    
                        z.name.slice(0, 3) === "END" ||
                        z.name.slice(0, 2) === "MO"
                    );
                }
                if (selectedType[i] === 3) {
                    filtered3 = filtered.filter(z =>
                        z.name.toLowerCase().includes('vorschreibungen') ||
                        z.name.slice(0, 2) === "VS"    
                    );
                }
                var all = [...filtered1, ...filtered2, ...filtered3]
                filtered = all;
                count++;
            }
        }

        if (count > 0) {
            filtered = filtered.sort((a, b) => b.downloaded - a.downloaded);
            setFilteredZips(filtered);
            countInvoiceTypes(filtered);
        }
        else {
            setFilteredZips(initialZips.sort((a, b) => b.downloaded - a.downloaded));
            countInvoiceTypes(initialZips);
        }
    }


    const getDateRangeString = () => {
        let date1 = new Date();
        let date2 = new Date();
        date1.setMonth(monthRange[0] - 1);
        date2.setMonth(monthRange[1] - 1);
        let from = date1.toLocaleDateString('DE-de', { month: 'long' })
        let till = date2.toLocaleDateString('DE-de', { month: 'long' })
        return `von ${from} bis ${till}`;
    }

    return (
        <>
            <Row className="mb-5">
                <h5 className="text-energo">Schnellzugriff</h5>
                {types.map(t => (
                    <InvoiceClassCard select={setSelectedType} selected={selectedType} type={t} key={t.id} />
                ))}
            </Row>

            <Card style={{borderRadius: "15px", borderLeft: "3px solid #a2c13f", borderBottom: "3px solid #a2c13f"}} className="shadow-lg">
                <Card.Header>
                    <Row className="align-items-center" style={{marginTop: "10px", marginBottom: "10px"}}>
                        <Col xs="12" md="4" xl="6" className="text-center">
                            <span className="text-energo">
                                {getDateRangeString()}
                            </span>
                            <RangeSlider
                                value={monthRange} onInput={setMonthRange}
                                step={1}
                                min={1}
                                max={12}
                            />
                        </Col>
                        <Col xs="6" md="4" xl="4" className="text-center">
                            <div className="dropdown">
                                <button className="btn btn-link drop-energo dropdown-toggle" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                    {selectedYear > 0 ? selectedYear : 'Jahr'}
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    {years?.map(y => (
                                        <li key={y} className="text-center">
                                            <a onClick={e => { e.preventDefault(); selectedYear === y ? setSelectedYear(0) : setSelectedYear(y) }} href="/filter/jahr" className="dropdown-item">
                                                <Row>
                                                    <Col xs="4" hidden={selectedYear !== y}>
                                                        <AiOutlineCheck />
                                                    </Col>
                                                    <Col xs={selectedYear === y ? "8" : "12"} className={selectedYear === y ? "text-start" : "text-center"}>
                                                        {y}
                                                    </Col>
                                                </Row>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                        <Col xs="6" md="4" xl="2">
                            <div style={{display: "inline-block", marginRight: "8px"}}>
                                <Form.Select defaultValue={maxItemsInPagination} onChange={e => setMaxItemsInPagination(e.target.value)}>
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={500}>500</option>
                                </Form.Select>
                            </div>
                            pro Seite
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body style={{padding: "1px 0 0 2px"}}>
                    <ListGroup>
                        {currentView?.length > 0 ?
                            currentView.map(z => (
                                <ZipsListItem key={z.name} zip={z} />
                            ))
                            :
                            <ListGroup.Item key="none:0">
                                <Row>
                                    <Col xl="12">Für den ausgewählten Zeitraum sind keine Dateien im Archiv verfügbar.</Col>
                                </Row>
                            </ListGroup.Item>
                        }
                    </ListGroup>
                    <div className="text-center" style={{ marginTop: "43px" }} hidden={filteredZips.length <= maxItemsInPagination}>
                        <EnergoPagination max={Math.ceil(filteredZips.length / maxItemsInPagination)} current={currentPage} select={setCurrentPage} />
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

export default ZipsList;